import { Text, Flex, SxStyleProp, AspectRatio } from 'theme-ui';
import { centeredContent } from 'utils/mixins';

export type AddSceneProps = {
  addHandler: () => void;
};

const styles: SxStyleProp = {
  ...centeredContent,
  borderStyle: 'solid',
  borderWidth: 2,
  borderRadius: 'default',
  cursor: 'pointer',
  borderColor: 'grey3',
  color: 'text',
  transition: 'border-color .2s ease-out',

  '&:hover': {
    borderColor: 'grey6',
    transition: 'border-color .2s ease-in'
  },

  '&:active': {
    borderColor: 'primary'
  }
};

export default ({ addHandler }: AddSceneProps) => (
  <AspectRatio ratio={1.42} sx={{ overflow: 'hidden', borderRadius: 'default' }}>
    <div sx={{ height: '100%' }}>
      <Flex sx={styles} onClick={addHandler} data-test="scene_add">
        <Text sx={{ fontSize: 6 }}>+</Text>
      </Flex>
    </div>
  </AspectRatio>
);
